import { defineRecipe } from '@chakra-ui/react';

export const buttonRecipe = defineRecipe({
  base: {
    colorPalette: 'navy',
    fontWeight: 400,
    fontSize: 'md',
  },
  defaultVariants: {
    variant: 'solid',
  },
  variants: {
    variant: {
      outline: {
        fontSize: 'md',
        _icon: {
          color: 'colorPalette.solid',
        },
        _hover: {
          bg: 'colorPalette.muted',
        },
      },
      solid: {
        fontSize: 'md',
        color: 'colorPalette.contrast !important',
        _icon: {
          color: 'colorPalette.contrast !important',
        },
      },
      link: {
        fontSize: 'md',
        _icon: {
          color: 'colorPalette.solid',
        },
      },
      ghost: {
        fontSize: 'md',
        _hover: {
          bg: 'gray.100',
        },
      },
    },
  },
});

export default buttonRecipe;
